import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { initialCommonFilterState } from "interfaces/FilterTypes";
import toast from "react-hot-toast";

export const customBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage?.getItem("token"); // or get from context/store
    const userInfo = localStorage?.getItem("role");

    if (token && token !== "undefined") {
      headers.set("Authorization", `Token ${JSON.parse(token)}`);
    }
    if (userInfo) {
      headers.set("x-gridkey-user-role", userInfo);
    }

    return headers;
  },
});

export function preloadState() {
  try {
    return {
      table: {
        columnsPersist: JSON.parse(localStorage.getItem("columns") || "{}"),
        columnsOrder: JSON.parse(localStorage.getItem("columns-order") || "{}"),
        columnsWidth: JSON.parse(localStorage.getItem("columns-width") || "{}"),
        commonFilter: initialCommonFilterState,
      },
    };
  } catch (error) {
    console.error("Failed to load state", error);
    return undefined;
  }
}

export const handleQueryLifecycle = async (
  queryFulfilled: Promise<any>,
  errorMsg = "Something went wrong, please try again.",
) => {
  try {
    const { data } = await queryFulfilled;
    toast.success(data?.message || "Action performed successfully");
  } catch (err: any) {
    toast.error(err?.error?.data?.message || errorMsg);
  }
};

export type BenchmarkKey =
  | "1M"
  | "3M"
  | "6M"
  | "1Y"
  | "thisFy"
  | "previousFy"
  | "sinceInception";
